<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M23.8305 32.3174L32.1479 24L23.8305 15.6825L21.0522 18.4891L24.5826 22.0195H15.85V25.9804H24.5826L21.0522 29.5109L23.8305 32.3174ZM24.0039 44.7065C21.1549 44.7065 18.4715 44.1666 15.9536 43.0868C13.4357 42.007 11.2362 40.5264 9.35486 38.6451C7.47359 36.7638 5.99304 34.5656 4.91321 32.0503C3.83337 29.535 3.29346 26.8529 3.29346 24.0039C3.29346 21.1216 3.83337 18.4215 4.91321 15.9036C5.99304 13.3857 7.47212 11.194 9.35046 9.3284C11.2288 7.4628 13.4262 5.98586 15.9429 4.8976C18.4596 3.80933 21.1432 3.2652 23.9938 3.2652C26.8776 3.2652 29.5796 3.8086 32.0998 4.8954C34.6199 5.9822 36.812 7.45715 38.6762 9.32025C40.5404 11.1833 42.0162 13.3742 43.1037 15.8928C44.1911 18.4115 44.7348 21.1139 44.7348 24C44.7348 26.8516 44.1907 29.5361 43.1024 32.0537C42.0141 34.5713 40.5372 36.7696 38.6716 38.6485C36.806 40.5275 34.6156 42.007 32.1003 43.0868C29.585 44.1666 26.8862 44.7065 24.0039 44.7065ZM24 40.7456C28.658 40.7456 32.6134 39.1168 35.8663 35.859C39.1192 32.6013 40.7457 28.6483 40.7457 24C40.7457 19.342 39.1192 15.3866 35.8663 12.1337C32.6134 8.8808 28.6533 7.25435 23.9859 7.25435C19.3518 7.25435 15.4047 8.8808 12.1446 12.1337C8.88442 15.3866 7.25436 19.3467 7.25436 24.0141C7.25436 28.6482 8.88322 32.5953 12.141 35.8554C15.3987 39.1156 19.3517 40.7456 24 40.7456Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
